import { TYPES } from "./incomeStaff.type";

const initState = {
  all: null,
  branch: null,
  userInfo: null,
  incomeByBranch: [],
};

const incomeStaffReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SELECT_ALL_INCOME_SUCCESS:
      return {
        ...state,
        all: payload,
      };
    case TYPES.SELECT_ALL_BRANCH_SUCCESS:
      return {
        ...state,
        branch: payload,
      };
    case TYPES.SELECT_USER_INFO_SUCCESS:
      return {
        ...state,
        userInfo: payload,
      };

    case TYPES.SELECT_ALL_INCOME_BY_BRANCH_SUCCESS:
      return {
        ...state,
        incomeByBranch: payload,
      };

    default:
      return state;
  }
};

export default incomeStaffReducer;
